import { NewsContentType } from '@/types/enum';
import image1 from '@/assets/images/news/detail/20211207/1.jpg';
import image2 from '@/assets/images/news/detail/20211207/2.jpg';
import image3 from '@/assets/images/news/detail/20211207/3.jpg';
import image4 from '@/assets/images/news/detail/20211207/4.jpg';
import image5 from '@/assets/images/news/detail/20211207/5.jpg';
import image6 from '@/assets/images/news/detail/20211207/6.jpg';
import image7 from '@/assets/images/news/detail/20211207/7.jpg';
import image8 from '@/assets/images/news/detail/20211207/8.jpg';
import image9 from '@/assets/images/news/detail/20211207/9.jpg';
import image10 from '@/assets/images/news/detail/20211207/10.jpg';
import image11 from '@/assets/images/news/detail/20211207/11.jpg';
import image12 from '@/assets/images/news/detail/20211207/12.jpg';
import image13 from '@/assets/images/news/detail/20211207/13.jpg';
import image14 from '@/assets/images/news/detail/20211207/14.jpg';
import image15 from '@/assets/images/news/detail/20211207/15.jpg';
import image16 from '@/assets/images/news/detail/20211207/16.jpg';
import image17 from '@/assets/images/news/detail/20211207/17.jpg';
import image18 from '@/assets/images/news/detail/20211207/18.jpg';

export default {
  id: '20211207', //  模块 id
  title: '2021叮咚买菜食品生鲜行业供应链生态峰会回顾', // 标题
  origin: '', // 新闻来源
  editor: '', // 编辑者
  content: [
    {
      type: NewsContentType.Text,
      text:
        '随着社会发展，人们越来越重视品质和食品安全问题，用户消费趋势也从“性价比”转向“品价比”，让人足够放心、有特色的好商品的需求正与日增多。这就给如今的零售商们带来了新的挑战，也促进了行业合作中零供关系的升级。',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '一、大会核心',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text:
        '12月3日，叮咚买菜在上海举办了一场食品生鲜行业供应链生态峰会，首次系统性地对外阐述了叮咚的供应链思路，与“商品力”背后的产品开发方向，并宣布与合作伙伴进入新的生态供应链协同阶段。',
    },
    {
      type: NewsContentType.Text,
      text:
        '“一个有担当的企业，应该能够构建好的生态，也能引领整个行业的进步。”叮咚买菜创始人兼CEO梁昌霖在大会中提到。',
    },
    {
      type: NewsContentType.Image,
      src: [image1],
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '从商品采购到商品开发，品控体系升级',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text:
        '目前，叮咚买菜专注于开发商品，优化品类结构，以满足细分人群的消费升级需求，在“人无我有、人有我优”方面，不断打造差异化商品。叮咚买菜要更多地走进源头，不管是标品还是生鲜农产品，要参与到全链路的开发中去。',
    },
    {
      type: NewsContentType.Text,
      text:
        '在非标的生鲜农产品方面，叮咚买菜通过订单农业来确保商品品质和供应链路的畅通；在标品与快手菜方面，叮咚买菜正在与有创新精神的生产商、品牌方进行联合开发与生产。',
    },
    {
      type: NewsContentType.Text,
      text:
        '为此，叮咚买菜还将原来的采销中心升级为商品开发中心，由叮咚买菜商品开发高级副总裁徐志坚带队，从市场趋势、用户痛点上着手，取代传统采购链路。叮咚买菜将以商品力为第一推动力，为人们提供安全、新鲜、高品价比的商品。',
    },
    {
      type: NewsContentType.Text,
      text:
        '从采购到商品开发的转变，团队不再是简单的采买，还要懂用户、懂原料、懂产地，比以往更关注消费者想要什么，更重视商品的差异化。',
    },
    {
      type: NewsContentType.Text,
      text:
        '叮咚买菜还进一步将商品规划及开发定义到四个方向：通过3R（即烹、即热、即食）食品的研发和生产，为家庭餐食场景提供美味便捷的解决方案；通过产地直采与订单农业，为消费者提供安全鲜活的生鲜食材；通过联合开发创新标品，为追求健康轻盈的用户提供轻食尖货；通过需求识别与商品开发，为不同细分人群提供科学的营养解决方案。',
    },
    {
      type: NewsContentType.Text,
      text:
        '而这也带来了更高的品控要求。一直以来，叮咚买菜严格执行“7+1”品控流程，在源头把控、总仓验收、加工分拣、前置仓验收、储存巡检、分拣打包、配送交付、反馈处理等环节保证品质确定性。',
    },
    {
      type: NewsContentType.Text,
      text:
        '如今在基础品控流程之上，叮咚买菜还将针对不同场景，推出更加细化的品控规范。',
    },
    {
      type: NewsContentType.Text,
      text:
        '叮咚买菜今年推出的“宝妈严选”儿童食品专区，就是在品控升级下产出的一个针对细分人群的更高品质的商品专区，该专区制定了专属的《儿童食品专区准入规范》，以“追根溯源、科学营养、更少添加、严苛品控”为底线，甄选出最适合3-15岁儿童的食材和营养解决方案。此外还将结合相关用户的需求研究，进一步定义创新商品，并与合作方实现商品的定制开发。',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '全链路生态伙伴共同成长',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text:
        '加大“商品力”建设的决心，正在对叮咚买菜和其伙伴的合作模式提出新的要求。',
    },
    {
      type: NewsContentType.Text,
      text:
        '一直以来，随着商业模式的进化与用户需求的演变，零供关系一直处在新的平衡与重塑之中。作为重点打造商品力和供应链生态的企业，叮咚买菜也一直团结供应商，建立更透明、更高效的合作关系，共同解决原来供需信息不对称、采销环节冗长低效等供应链痛点。',
    },
    {
      type: NewsContentType.Text,
      text:
        '目前，叮咚买菜已基本实现从传统采销模式往生态型供应链的转型，跑通了订单生产-品控升级-合作链路优化-共同开发-联合营销-销情反馈这一完整链路。',
    },
    {
      type: NewsContentType.Text,
      text:
        '基于算法的订单预测，叮咚买菜所需的商品可以在生产端提前投入生产，确保订单能准时交货，以及交付的订单能按计划销售。在不断升级的品控体系下，继续提高供应商准入标准，定制开发出高于市场标准的差异化商品。',
    },
    {
      type: NewsContentType.Text,
      text:
        '而对供应商的扶持上，叮咚买菜一直采用无进场费、无条码费、无特殊供应商渠道的“0门槛”入场方式。全程合同管理电子化，报价议价过程公平、透明，内部审批流程扁平、高效，避免渠道为王与压榨式合作，并通过供应链金融服务为合作伙伴提供无账期的资金保障。',
    },
    {
      type: NewsContentType.Text,
      text:
        '商品上架之后，叮咚买菜摒弃传统中品牌渠道分离、各自高高挂起的方式，与品牌方进行联合营销，利用叮咚买菜“咚风计划”方案，相互进行资源扶持，共同打造爆品。',
    },
    {
      type: NewsContentType.Text,
      text:
        '最后，平台也会将销售表现、用户好评度、渗透率、复购率等商品表现，反馈到供应端，以便双方对商品进行共同优化，实现闭环。',
    },
    {
      type: NewsContentType.Text,
      text:
        '“从生产源头到销售端，建立产销健康协同、上下游一体化、中间无博弈、共赋能的端到端供应链生态，实现用户价值最大化、全链路高效率的目标。”叮咚买菜商品开发高级副总裁徐志坚总结道。',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '二、大会过程',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '特邀嘉宾致辞',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Image,
      src: [image2],
    },
    {
      type: NewsContentType.Text,
      text: '中国电商乡村振兴联盟 副主席兼秘书长',
    },
    {
      type: NewsContentType.Text,
      text: '陶 鸣',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Image,
      src: [image3],
    },
    {
      type: NewsContentType.Text,
      text: '中国物流与采购联合会农产品供应链分会 秘书长',
    },
    {
      type: NewsContentType.Text,
      text: '秦玉鸣',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '主旨发言',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Image,
      src: [image4],
    },
    {
      type: NewsContentType.Text,
      text: '《以科学规范的食品安全保障体系助力商品力建设》',
    },
    {
      type: NewsContentType.Text,
      text: '叮咚买菜研究院院长 申强',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Image,
      src: [image5],
    },
    {
      type: NewsContentType.Text,
      text: '《规范化养殖提升水产食品安全与品质》',
    },
    {
      type: NewsContentType.Text,
      text: '上海海洋大学水产与生命学院院长 谭洪新',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Image,
      src: [image6],
    },
    {
      type: NewsContentType.Text,
      text: '《用数智化和冷链科技为供应链生态建设赋能》',
    },
    {
      type: NewsContentType.Text,
      text: '叮咚买菜首席供应链官 杨平',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Image,
      src: [image7],
    },
    {
      type: NewsContentType.Text,
      text: '《叮咚买菜商品力及供应链生态建设》',
    },
    {
      type: NewsContentType.Text,
      text: '叮咚买菜商品开发高级副总裁 徐志坚',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Image,
      src: [image8],
    },
    {
      type: NewsContentType.Text,
      text: '《基于用户需求推动商品创新开发》',
    },
    {
      type: NewsContentType.Text,
      text: '叮咚买菜商品规划与创新中心高级经理 邱爽',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Image,
      src: [image9],
    },
    {
      type: NewsContentType.Text,
      text: '《2022年叮咚买菜品牌联合营销计划》',
    },
    {
      type: NewsContentType.Text,
      text: '叮咚买菜市场营销副总监 罗丽媛',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Image,
      src: [image10],
    },
    {
      type: NewsContentType.Image,
      src: [image11],
    },
    {
      type: NewsContentType.Image,
      src: [image12],
    },
    {
      type: NewsContentType.Text,
      text: '《优秀合作品牌案例分享》',
    },
    {
      type: NewsContentType.Text,
      text: '丽坤楼、桂冠、黄天鹅',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Image,
      src: [image13],
    },
    {
      type: NewsContentType.Text,
      text: '《2022年叮咚买菜家乡味道项目发布》',
    },
    {
      type: NewsContentType.Text,
      text: '叮咚买菜快手菜高级商品开发总监 欧厚喜',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '颁奖典礼',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Image,
      src: [image14],
    },
    {
      type: NewsContentType.Text,
      text: '营销食力·年度最佳营销案例',
    },
    {
      type: NewsContentType.Text,
      text: '优益C、太太乐、金典、元气森林、如实、三全、家乐、桂冠、首农、统一',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Image,
      src: [image15],
    },
    {
      type: NewsContentType.Text,
      text: '口碑食力·年度最受用户欢迎品牌',
    },
    {
      type: NewsContentType.Text,
      text:
        '光明、海天、农夫山泉、恒都、卡士、正大、每日鲜语、泰森、可口可乐、桃李',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Image,
      src: [image16],
    },
    {
      type: NewsContentType.Text,
      text: '品质食力·年度品质杰出供应商',
    },
    {
      type: NewsContentType.Text,
      text: '深圳市晨光乳业有限公司',
    },
    {
      type: NewsContentType.Text,
      text: '湘村高科农业股份有限公司',
    },
    {
      type: NewsContentType.Text,
      text: '光明渔业有限公司',
    },
    {
      type: NewsContentType.Text,
      text: '浙江顶誉食品有限公司',
    },
    {
      type: NewsContentType.Text,
      text: '江苏益客食品集团股份有限公司',
    },
    {
      type: NewsContentType.Text,
      text: '明康汇生态农业集团有限公司',
    },
    {
      type: NewsContentType.Text,
      text: '上海清美绿色食品（集团）有限公司',
    },
    {
      type: NewsContentType.Text,
      text: '北京二商希杰食品有限责任公司',
    },
    {
      type: NewsContentType.Text,
      text: '四川凤集生态农业发展有限公司',
    },
    {
      type: NewsContentType.Text,
      text: '昆明方德波尔格玫瑰花卉有限公司',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Image,
      src: [image17],
    },
    {
      type: NewsContentType.Text,
      text: '服务食力·年度6星服务供应商',
    },
    {
      type: NewsContentType.Text,
      text: '福建海中舟海洋渔业发展有限公司',
    },
    {
      type: NewsContentType.Text,
      text: '上海紫昊食品有限公司',
    },
    {
      type: NewsContentType.Text,
      text: '上海丽昆楼食品有限公司',
    },
    {
      type: NewsContentType.Text,
      text: '无锡安井食品营销有限公司',
    },
    {
      type: NewsContentType.Text,
      text: '内蒙古伊利实业集团股份有限公司金山分公司',
    },
    {
      type: NewsContentType.Text,
      text: '山东优形食品科技有限公司',
    },
    {
      type: NewsContentType.Text,
      text: '北京三元食品股份有限公司',
    },
    {
      type: NewsContentType.Text,
      text: '上海盘点食品科技有限公司',
    },
    {
      type: NewsContentType.Text,
      text: '珠海市利源农畜产品有限公司',
    },
    {
      type: NewsContentType.Text,
      text: '上海妙禾食品配送有限公司',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Image,
      src: [image18],
    },
    {
      type: NewsContentType.Text,
      text: '匠心食力·年度食力贡献农业匠人',
    },
    {
      type: NewsContentType.Text,
      text: '卜博士的伊丽莎红番茄和安全韭菜',
    },
    {
      type: NewsContentType.Text,
      text: '周伟建的咔酷奇番茄',
    },
    {
      type: NewsContentType.Text,
      text: '李进福的 Low GI土豆（低升糖指数土豆）',
    },
    {
      type: NewsContentType.Text,
      text: '黄庆华的沃柑',
    },
    {
      type: NewsContentType.Text,
      text: '杨福刚的JAP优饲鲈鱼',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '在未来',
    },
    {
      type: NewsContentType.Text,
      text: '叮咚买菜与用户、合作伙伴的关系将更加紧密',
    },
    {
      type: NewsContentType.Text,
      text: '这也将带动着整个零供体系变得更加健康',
    },
    {
      type: NewsContentType.Text,
      text: '拥有更强的生命力',
    },
    {
      type: NewsContentType.Text,
      text: '让我们期待明年的再次相遇',
    },
    {
      type: NewsContentType.Text,
      text: '供稿 | 市场部',
    },
    {
      type: NewsContentType.Text,
      text: '编发 | 行政部',
    },
  ],
};
